import FeesCard from "./FeesCard";

export default function Class8() {
  return (
    <FeesCard
        badge="Class 8"
        title="💰 Class 8 Tuition Details"
        className="8th Standard"
        fee="₹1,500"
        days="Monday – Saturday"
        time="4:30 PM – 7:30 PM"
        subjects={[
          "Mathematics",
          "Science",
          "English",
          "Social Science"
        ]}
        approach={[
          "Board foundation focus",
          "Regular assessments",
          "Strategic learning"
        ]}
        note="₹500 extra for evening snacks / milk.
        Self pickup & drop only."
      />
  );
}